import { AuthFrame } from "./AuthFrame";

export const SignupPage = () => <AuthFrame view="signup" />;
